// src/docs/DocsHoldings.js
import React from "react";
import { Container, Typography } from "@mui/material";

const DocsHoldings = () => {
  return (
    <Container maxWidth="md" sx={{ my: 4 }}>
      {/* Page Title */}
      <Typography variant="h5" sx={{ color: "#FFD700", mb: 3 }}>
        Managing Your Holdings (Portfolio)
      </Typography>

      {/* Introduction */}
      <Typography variant="body1" sx={{ color: "#FFFFFF", mb: 3 }}>
        Your portfolio on CrowdLaunch serves as a central hub for tracking and managing all your tokenized shares. This dashboard offers a real‐time overview of your holdings, including share balances, shares in various projects, and performance metrics.
      </Typography>

      {/* Managing Shares through Your Wallet */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        Managing Shares via Your Injected Wallet
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 3 }}>
        CrowdLaunch leverages decentralized technology, which means your tokenized shares are securely stored in your injected wallet (e.g., MetaMask). You maintain complete control over your assets:
        <br /><br />
        • <strong>Transfer Shares:</strong> Easily send or receive tokens using your wallet's native transfer functionality.
        <br />• <strong>Full Ownership:</strong> Your wallet acts as the primary custodian, ensuring that you have direct control over your holdings.
        <br />• <strong>Security:</strong> Since transactions occur through your wallet interface, you can verify and confirm each action, enhancing security.
      </Typography>

      {/* Tracking Your Portfolio */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        Tracking Your Portfolio
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 3 }}>
        The CrowdLaunch portfolio dashboard is designed to give you a comprehensive view of your investments:
        <br /><br />
        • <strong>Share Balances:</strong> View real-time balances of all your tokenized projects.
        <br />• <strong>Performance Metrics:</strong> Monitor changes in value and performance over time.
      </Typography>

      {/* Conclusion */}
      <Typography variant="body1" sx={{ color: "#FFFFFF", mt: 4 }}>
        By combining the power of your injected wallet with the detailed insights available on the portfolio dashboard, CrowdLaunch ensures that managing your tokenized assets is both secure and intuitive. Whether you’re transferring shares or simply monitoring your investments, you have all the necessary tools at your fingertips.
      </Typography>
    </Container>
  );
};

export default DocsHoldings;
